const translationEnabledLanguageDialog = {
  props: {
    activeDialogs: [],
    selectors: {
      cmp: ".translation-enabled-language-dialog-JS",
      closeButton: ".close-button-JS",
      sourceLanguageButton: ".source-language-button-JS",
      targetLanguageButton: ".target-language-button-JS",
      languageSelectOption: 'link[rel="translate"]',
    },
    placeholders: {
      currentLanguage: "[currentlanguage]",
      targetLanguage: "[targetlanguage]",
    },
  },
  init: function () {
    if (sessionStorage.getItem(bcl.s.translateOnTheFly.props.sessionStorageEnabledLanguageProp)) {
      return;
    }
    const currentLanguage = document.documentElement.lang;
    const userLanguage = [bcl.u.getCountryCode(), navigator.language];
    let targetTranslationLanguage;
    document.querySelectorAll(this.props.selectors.languageSelectOption).forEach(function ($translationEnabledLanguageInput) {
      const translationEnabledLanguage = $translationEnabledLanguageInput.dataset.code;
      for (const language of userLanguage) {
        targetTranslationLanguage = targetTranslationLanguage || (translationEnabledLanguage.toLowerCase().startsWith(language.toLowerCase()) && translationEnabledLanguage);
      }
    });
    if (!targetTranslationLanguage) {
      return;
    }
    let currentLanguageLabel = document.querySelector(`link[hreflang="${currentLanguage}" i][data-label]`)?.dataset.label;
    let targetLanguageLabel = document.querySelector(`link[data-code="${targetTranslationLanguage}" i]`)?.dataset.label;

    const translation = bcl.s.translateOnTheFly.onlyText([currentLanguageLabel, targetLanguageLabel], currentLanguage, targetTranslationLanguage);
    if (translation) {
      currentLanguageLabel = translation.response?.data?.items[1]?.translationText || currentLanguageLabel;
      targetLanguageLabel = translation.response?.data?.items[0]?.translationText || targetLanguageLabel;
    }

    targetTranslationLanguage &&
      document.querySelectorAll(`[data-translation-enabled-language="${targetTranslationLanguage}"] ${this.props.selectors.cmp}`).forEach(
        function ($cmp) {
          const $dialog = $cmp.closest(".hidden");

          $cmp.innerHTML = $cmp.innerHTML.replaceAll(this.props.placeholders.currentLanguage, currentLanguageLabel).replaceAll(this.props.placeholders.targetLanguage, targetLanguageLabel);
          const $closeButton = $cmp.querySelector(this.props.selectors.closeButton);
          const $sourceLanguageButton = $cmp.querySelector(this.props.selectors.sourceLanguageButton);
          const $targetLanguageButton = $cmp.querySelector(this.props.selectors.targetLanguageButton);

          $closeButton.addEventListener("click", this.closeDialog.bind(this, $dialog, this.removeSessionStorageData.bind(this)));
          $sourceLanguageButton.addEventListener("click", this.closeDialog.bind(this, $dialog, this.removeSessionStorageData.bind(this)));
          $targetLanguageButton.addEventListener("click", this.closeDialog.bind(this, $dialog, this.setTargetLanguage.bind(this, currentLanguage, targetTranslationLanguage)));

          this.openDialog($dialog);
        }.bind(this),
      );
  },
  closeDialog: function ($dialog, callback) {
    $dialog.classList.add("hidden");
    sessionStorage.setItem("barcelo_languageRibbon", new Date().toString());
    if (callback && typeof callback === "function") {
      callback();
    }
    const activeDialogs = bcl.c.translationEnabledLanguageDialog.props.activeDialogs;
    activeDialogs.splice(activeDialogs.indexOf($dialog), 1);
  },
  openDialog: function ($dialog) {
    $dialog.classList.remove("hidden");
    bcl.c.translationEnabledLanguageDialog.props.activeDialogs.push($dialog);
  },
  removeSessionStorageData: function () {
    sessionStorage.removeItem(bcl.s.translateOnTheFly.props.sessionStorageEnabledLanguageProp);
  },
  setTargetLanguage: function (currentLanguage, targetLanguage) {
    sessionStorage.setItem(bcl.s.translateOnTheFly.props.sessionStorageEnabledLanguageProp, targetLanguage);
    bcl.s.translateOnTheFly.initTranslate(currentLanguage, targetLanguage);
  },
  closeAll: function () {
    bcl.c.translationEnabledLanguageDialog.props.activeDialogs.forEach(bcl.c.translationEnabledLanguageDialog.closeDialog);
  },
};

export default translationEnabledLanguageDialog;
